// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imagesBacklog_FiUzT {
  margin-left: 20px;
  margin-right: 20px;
}
.imagesBacklog2_V6CzR {
  margin-top: 13px;
}
.btnStartQaComlete_XRjFd {
  margin-top: 14px;
}
.createTaskBtn_pC_Cg {
  margin-left: 1100px;
}
.todoCard_shE58 {
  width: 97%;
  overflow: hidden;
  word-break: break-word;
  background-color: rgba(241, 234, 234, 0.699);
  margin-bottom: 5px;
}
.todoIcons_CeeiG {
  font-size: 20px;
  margin-right: 10px;
  cursor: pointer;
}
.iconContainer_b0nCW {
  background-color: #f7f1f1;
  padding: 8px;
  padding-left: 15px;
  padding-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.todoAllIconContainer_OnEMj {
  display: flex;
  align-items: center;
}
.todoItem_v7jSq {
  margin-bottom: 8px;
}
.todoAvatarContainer_gAJ1B {
  margin-left: 200px;
  display: flex;
  align-items: center;
  font-size: 10px;
}
.addTaskCard_PwOjo {
  width: 98%;
  overflow: hidden;
  word-break: break-word;
  background-color: #d3d3d3;
}
.addTaskIconCol_oqTHp {
  font-size: 18px;
}
.addTaskIcon_XVLMf {
  margin-right: 5px;
}
.attachmentDiv_aW8PO {
  background-color: #a5a5a5;
  padding: 2px;
}
.textFunctionality_Rgy5Q {
  display: flex;
  align-items: center;
  font-size: 20px;
  border: 1px solid;
  border-color: black;
}
.textFunctionalityDiv_X2tRo {
  margin-right: 7px;
  margin-left: 7px;
}
.reactQuillTodoList_ei1Tc {
  width: 780px;
}
.allCommentsHistory_UOZ_f {
  display: flex;
  align-items: center;
  background-color: gray;
  margin-right: 5px;
  padding: 2px;
  padding-left: 8px;
  padding-right: 8px;
}
.list_zSzyh {
  display: flex;
  /* Use flexbox */
  flex-wrap: wrap;
  /* Allow items to wrap to the next line if needed */
  justify-content: flex-start;
  /* Align items from left to right */
  gap: 16px;
  /* Space between items */
}
.addTaskIconColField_f1bDI {
  margin-left: 14px;
}
.addTaskIconColSwitch_T4Bw4 {
  margin-left: -5px;
}
.addTaskIconColStaff_rqKTJ {
  margin-left: 4px;
}
.tasknameStyles_uyzpQ {
  border-bottom: dotted 1px;
  margin-bottom: 10px;
  border-color: gray;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.circle_rzY8o {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-left: 5px;
  background-color: red;
  margin-top: 7px;
  padding-left: 5px;
}
.filterCircleColor_VDDkq {
  display: flex;
  justify-content: space-between;
  margin-left: 700px;
}
.mainRow_pLDmU {
  display: flex;
}
.sprintListContainer_xhXWw {
  display: flex;
  align-items: center;
}
.sprintListElipseStyle__6FB7 {
  font-size: 24px;
  margin-left: 10px;
}
.backlogHeaderContainerdiv_bNPhJ {
  width: 100%;
  margin-bottom: 10px;
}
.backlogHeaderContainer_ulXk6:active {
  color: gray;
}
.BacklogHeader_pZ7YS {
  display: flex;
  justify-content: space-between;
}
.formOutlineBackogCollapse_jtSuD {
  margin-left: 10px;
}
.sprintBackListTable_Jsi_s {
  margin-top: -20px;
}
.sprintListoutStyles_lqZ7B {
  width: 100%;
  margin-bottom: 5px;
}
.sprintListCollapsePanel_B_itg {
  margin-bottom: 10px;
  width: 100%;
}
.backlogColumnDiv_6Zo94 {
  display: flex;
}
.editOutLinedSprintList_VGOyi {
  margin-left: 10px;
}
.startSprintButtonSprintList_eaGco {
  display: flex;
  margin-left: 700px;
}
.EllipsisOutlinedSprintList_pVBzU {
  font-size: 20px;
  margin-top: 8px;
}
.taskAndColor_AYzmC {
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
}
.todoAssignAvatar_GoeqB {
  display: flex;
  margin-right: 2px;
  justify-content: space-between;
}
.todotaskassignedname_qTcxA {
  margin-top: 7px;
  margin-right: 2px;
  font-size: 12px;
}
.chatSearchMain_NwdJ7 {
  background-color: #1d4f7a;
}
.wrap_text_tx5in {
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
.dateWidth_sRirv {
  position: absolute;
  width: 100%;
  top: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/HelpDesk/createTask/createaskcss.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;AACJ;AAEA;EACI,gBAAA;AAAJ;AAGA;EACI,gBAAA;AADJ;AAIA;EACI,mBAAA;AAFJ;AAKA;EACI,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,4CAAA;EACA,kBAAA;AAHJ;AAMA;EACI,eAAA;EACA,kBAAA;EACA,eAAA;AAJJ;AAOA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAQA;EACI,aAAA;EACA,mBAAA;AANJ;AASA;EACI,kBAAA;AAPJ;AAUA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AARJ;AAWA;EACI,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AATJ;AAYA;EACI,eAAA;AAVJ;AAaA;EACI,iBAAA;AAXJ;AAcA;EACI,yBAAA;EACA,YAAA;AAZJ;AAeA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAbJ;AAgBA;EACI,iBAAA;EACA,gBAAA;AAdJ;AAiBA;EACI,YAAA;AAfJ;AAkBA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhBJ;AAmBA;EACI,aAAA;EAjBF,gBAAgB;EAkBd,eAAA;EAhBF,mDAAmD;EAiBjD,2BAAA;EAfF,mCAAmC;EAgBjC,SAAA;EAdF,wBAAwB;AAC1B;AAgBA;EACI,iBAAA;AAdJ;AAiBA;EACI,iBAAA;AAfJ;AAkBA;EACI,gBAAA;AAhBJ;AAmBA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAjBJ;AAoBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAlBJ;AAqBA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AAnBJ;AAsBA;EACI,aAAA;AApBJ;AAuBA;EACI,aAAA;EACA,mBAAA;AArBJ;AAwBA;EACI,eAAA;EACA,iBAAA;AAtBJ;AAyBA;EACI,WAAA;EACA,mBAAA;AAvBJ;AA0BA;EACI,WAAA;AAxBJ;AA2BA;EACI,aAAA;EACA,8BAAA;AAzBJ;AA4BA;EACI,iBAAA;AA1BJ;AA6BA;EACI,iBAAA;AA3BJ;AA8BA;EACI,WAAA;EACA,kBAAA;AA5BJ;AA+BA;EACI,mBAAA;EACA,WAAA;AA7BJ;AAgCA;EACI,aAAA;AA9BJ;AAiCA;EACI,iBAAA;AA/BJ;AAkCA;EACI,aAAA;EACA,kBAAA;AAhCJ;AAmCA;EACI,eAAA;EACA,eAAA;AAjCJ;AAoCA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAlCJ;AAqCA;EACI,aAAA;EACA,iBAAA;EACA,8BAAA;AAnCJ;AAsCA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;AApCJ;AAuCA;EACI,yBAAA;AArCJ;AAwCA;EACI,8BAAA;EACA,iCAAA;EACA,oCAAA;AAtCJ;AAyCA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;AAvCJ","sourcesContent":[".imagesBacklog {\n    margin-left: 20px;\n    margin-right: 20px;\n}\n\n.imagesBacklog2 {\n    margin-top: 13px;\n}\n\n.btnStartQaComlete {\n    margin-top: 14px;\n}\n\n.createTaskBtn {\n    margin-left: 1100px;\n}\n\n.todoCard {\n    width: 97%;\n    overflow: hidden;\n    word-break: break-word;\n    background-color: rgba(241, 234, 234, 0.699);\n    margin-bottom: 5px;\n}\n\n.todoIcons {\n    font-size: 20px;\n    margin-right: 10px;\n    cursor: pointer;\n}\n\n.iconContainer {\n    background-color: rgb(247, 241, 241);\n    padding: 8px;\n    padding-left: 15px;\n    padding-right: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.todoAllIconContainer {\n    display: flex;\n    align-items: center;\n}\n\n.todoItem {\n    margin-bottom: 8px;\n}\n\n.todoAvatarContainer {\n    margin-left: 200px;\n    display: flex;\n    align-items: center;\n    font-size: 10px;\n}\n\n.addTaskCard {\n    width: 98%;\n    overflow: hidden;\n    word-break: break-word;\n    background-color: rgb(211, 211, 211);\n}\n\n.addTaskIconCol {\n    font-size: 18px;\n}\n\n.addTaskIcon {\n    margin-right: 5px;\n}\n\n.attachmentDiv {\n    background-color: rgb(165, 165, 165);\n    padding: 2px;\n}\n\n.textFunctionality {\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    border: 1px solid;\n    border-color: black;\n}\n\n.textFunctionalityDiv {\n    margin-right: 7px;\n    margin-left: 7px;\n}\n\n.reactQuillTodoList {\n    width: 780px;\n}\n\n.allCommentsHistory {\n    display: flex;\n    align-items: center;\n    background-color: gray;\n    margin-right: 5px;\n    padding: 2px;\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.list {\n    display: flex; /* Use flexbox */\n    flex-wrap: wrap; /* Allow items to wrap to the next line if needed */\n    justify-content: flex-start; /* Align items from left to right */\n    gap: 16px; /* Space between items */\n}\n\n.addTaskIconColField {\n    margin-left: 14px;\n}\n\n.addTaskIconColSwitch {\n    margin-left: -5px;\n}\n\n.addTaskIconColStaff {\n    margin-left: 4px;\n}\n\n.tasknameStyles {\n    border-bottom: dotted 1px;\n    margin-bottom: 10px;\n    border-color: gray;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.circle {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-left: 5px;\n    background-color: red;\n    margin-top: 7px;\n    padding-left: 5px;\n}\n\n.filterCircleColor {\n    display: flex;\n    justify-content: space-between;\n    margin-left: 700px;\n}\n\n.mainRow {\n    display: flex;\n}\n\n.sprintListContainer {\n    display: flex;\n    align-items: center;\n}\n\n.sprintListElipseStyle {\n    font-size: 24px;\n    margin-left: 10px;\n}\n\n.backlogHeaderContainerdiv {\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n.backlogHeaderContainer:active {\n    color: gray;\n}\n\n.BacklogHeader {\n    display: flex;\n    justify-content: space-between;\n}\n\n.formOutlineBackogCollapse {\n    margin-left: 10px;\n}\n\n.sprintBackListTable {\n    margin-top: -20px;\n}\n\n.sprintListoutStyles {\n    width: 100%;\n    margin-bottom: 5px;\n}\n\n.sprintListCollapsePanel {\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.backlogColumnDiv {\n    display: flex;\n}\n\n.editOutLinedSprintList {\n    margin-left: 10px;\n}\n\n.startSprintButtonSprintList {\n    display: flex;\n    margin-left: 700px;\n}\n\n.EllipsisOutlinedSprintList {\n    font-size: 20px;\n    margin-top: 8px;\n}\n\n.taskAndColor {\n    display: flex;\n    justify-content: space-between;\n    white-space: nowrap;\n}\n\n.todoAssignAvatar {\n    display: flex;\n    margin-right: 2px;\n    justify-content: space-between;\n}\n\n.todotaskassignedname {\n    margin-top: 7px;\n    margin-right: 2px;\n    font-size: 12px;\n}\n\n.chatSearchMain {\n    background-color: rgb(29, 79, 122);\n}\n\n.wrap_text {\n    white-space: normal !important;\n    word-break: break-word !important;\n    overflow-wrap: break-word !important;\n}\n\n.dateWidth {\n    position: absolute;\n    width: 100%;\n    top: 0px !important;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imagesBacklog": `imagesBacklog_FiUzT`,
	"imagesBacklog2": `imagesBacklog2_V6CzR`,
	"btnStartQaComlete": `btnStartQaComlete_XRjFd`,
	"createTaskBtn": `createTaskBtn_pC_Cg`,
	"todoCard": `todoCard_shE58`,
	"todoIcons": `todoIcons_CeeiG`,
	"iconContainer": `iconContainer_b0nCW`,
	"todoAllIconContainer": `todoAllIconContainer_OnEMj`,
	"todoItem": `todoItem_v7jSq`,
	"todoAvatarContainer": `todoAvatarContainer_gAJ1B`,
	"addTaskCard": `addTaskCard_PwOjo`,
	"addTaskIconCol": `addTaskIconCol_oqTHp`,
	"addTaskIcon": `addTaskIcon_XVLMf`,
	"attachmentDiv": `attachmentDiv_aW8PO`,
	"textFunctionality": `textFunctionality_Rgy5Q`,
	"textFunctionalityDiv": `textFunctionalityDiv_X2tRo`,
	"reactQuillTodoList": `reactQuillTodoList_ei1Tc`,
	"allCommentsHistory": `allCommentsHistory_UOZ_f`,
	"list": `list_zSzyh`,
	"addTaskIconColField": `addTaskIconColField_f1bDI`,
	"addTaskIconColSwitch": `addTaskIconColSwitch_T4Bw4`,
	"addTaskIconColStaff": `addTaskIconColStaff_rqKTJ`,
	"tasknameStyles": `tasknameStyles_uyzpQ`,
	"circle": `circle_rzY8o`,
	"filterCircleColor": `filterCircleColor_VDDkq`,
	"mainRow": `mainRow_pLDmU`,
	"sprintListContainer": `sprintListContainer_xhXWw`,
	"sprintListElipseStyle": `sprintListElipseStyle__6FB7`,
	"backlogHeaderContainerdiv": `backlogHeaderContainerdiv_bNPhJ`,
	"backlogHeaderContainer": `backlogHeaderContainer_ulXk6`,
	"BacklogHeader": `BacklogHeader_pZ7YS`,
	"formOutlineBackogCollapse": `formOutlineBackogCollapse_jtSuD`,
	"sprintBackListTable": `sprintBackListTable_Jsi_s`,
	"sprintListoutStyles": `sprintListoutStyles_lqZ7B`,
	"sprintListCollapsePanel": `sprintListCollapsePanel_B_itg`,
	"backlogColumnDiv": `backlogColumnDiv_6Zo94`,
	"editOutLinedSprintList": `editOutLinedSprintList_VGOyi`,
	"startSprintButtonSprintList": `startSprintButtonSprintList_eaGco`,
	"EllipsisOutlinedSprintList": `EllipsisOutlinedSprintList_pVBzU`,
	"taskAndColor": `taskAndColor_AYzmC`,
	"todoAssignAvatar": `todoAssignAvatar_GoeqB`,
	"todotaskassignedname": `todotaskassignedname_qTcxA`,
	"chatSearchMain": `chatSearchMain_NwdJ7`,
	"wrap_text": `wrap_text_tx5in`,
	"dateWidth": `dateWidth_sRirv`
};
export default ___CSS_LOADER_EXPORT___;
